import React, { Fragment } from "react";
import {  useSelector, useDispatch } from 'react-redux';
import { updateAPIStatus } from '../Actions/Vat.action';
import { translate } from '../Services/translation';
const VATHeading = () => {
    const showVat = useSelector((state) => state.vat.value);
    const { showVatSection } = window.__litium.websiteConfig;

    const dispatch = useDispatch();
    return (
        <Fragment>
            {showVatSection && (
                <div className="vat-outer">
                    <a className={showVat ? 'active' : ''} onClick={() => dispatch(updateAPIStatus("/api/VAT/SetStatus", {status: true})) }> {translate('vat.include')}</a>
                    <a className={showVat ? '' : 'active'} onClick={() => dispatch(updateAPIStatus("/api/VAT/SetStatus", {status: false})) }> {translate('vat.exclude')}</a>
                </div>
            )}
        </Fragment>
    );
};

export default VATHeading;